import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Util from 'utility';
import api from 'api';
import { Locale, __ } from 'locale';


import {
    setAppSubMode,
    setLectureTaskComplete,
    openModal,
    closeModal,
    setLastSavedAt
} from 'actions/index';

import TaskEvaluator from './TaskEvaluator';
import EvaluationPanel from 'components/EvaluationPanel';
import { isAfter } from 'date-fns';

const mapStateToProps = state => {
    return { data: state };
}

const mapDispatchToProps = dispatch => {
    return {
        setAppSubMode: data => dispatch(setAppSubMode(data)),
        setLectureTaskComplete: data => dispatch(setLectureTaskComplete(data)),
        openModal: (data) => dispatch(openModal(data)),
        closeModal: (data) => dispatch(closeModal(data)),
        setLastSavedAt: (data) => dispatch(setLastSavedAt(data)),
    };
};

class LectureTaskPlan extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showSaveWarning: false,
            lastSaveWarningTime: 0,
        };

        this.openLectureTaskSampleMenu = this.openLectureTaskSampleMenu.bind(this);
        this.updateTaskCompletionStatus = this.updateTaskCompletionStatus.bind(this);
        this.showTaskListDDDInfoFunc = this.showTaskListDDDInfoFunc.bind(this);
        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        const d = Date.now();
        this.props.setLastSavedAt(d);
        this.timerID = setInterval(
            () => this.tick(),
            2000
        );

        this.updateTaskCompletionStatus();
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateTaskCompletionStatus();
    }


    updateTaskCompletionStatus() {
        const isComplete = this.isTaskCompleted();

        if (isComplete && !this.props.data.lectureTaskComplete) {
            this.props.setLectureTaskComplete(true);
        }

        if (!isComplete && this.props.data.lectureTaskComplete) {
            this.props.setLectureTaskComplete(false);
        }
    }




    isTaskCompleted() {
        const { data } = this.props;
        const taskData = data.lectureTaskData;

        if (typeof taskData.lecture_data !== 'object') return false;

        // Check group names and descriptions
        let allFoodGroupsHaveNames = true;
        let allFoodGroupsHaveDescriptions = true;

        Object.keys(this.props.data.foodGroups).forEach(m => {
            let ma = m.split('|');
            if (ma[0] === "0") return;
            const fgm = this.props.data.foodGroups[m];
            Object.keys(fgm).forEach(fg => {
            const g = fgm[fg];
            if (g.title.trim() === '') allFoodGroupsHaveNames = false;
            const gdesc = g.description ?? '';
            if (gdesc.trim() === '') allFoodGroupsHaveDescriptions = false;
            });
        });

        const er = this.props.data.evaluationResultsNk;
        if (typeof er !== 'object') return false;

        let hasMissing = false, hasWrongAmount = false, hasWrongPrep = false, hasExcess = false;

        let allFoodsOk = true;
        for (let i in er.results.required) {
            const item = er.results.required[i];
            if (item.is_ok !== true) {
                allFoodsOk = false;
                break;
            }
        }

        if (er.results.excess.length > 0) hasExcess = true;

        return (
            allFoodGroupsHaveNames &&
            allFoodGroupsHaveDescriptions &&
            allFoodsOk && 
            !hasExcess
        );
    }



    isTaskCompleted_OLD() {
        const { data } = this.props;
        const taskData = data.lectureTaskData;

        if (typeof taskData.lecture_data !== 'object') return false;

        // Check group names and descriptions
        let allFoodGroupsHaveNames = true;
        let allFoodGroupsHaveDescriptions = true;

        Object.keys(this.props.data.foodGroups).forEach(m => {
            let ma = m.split('|');
            if (ma[0] === "0") return;
            const fgm = this.props.data.foodGroups[m];
            Object.keys(fgm).forEach(fg => {
            const g = fgm[fg];
            if (g.title.trim() === '') allFoodGroupsHaveNames = false;
            const gdesc = g.description ?? '';
            if (gdesc.trim() === '') allFoodGroupsHaveDescriptions = false;
            });
        });

        const er = this.props.data.evaluationResultsNk;
        if (typeof er !== 'object') return false;

        let hasMissing = false, hasWrongAmount = false, hasWrongPrep = false, hasExcess = false;

        for (let i in er.results.required) {
            const item = er.results.required[i];
            if (item.missing) hasMissing = true;
            if (!item.missing && item.user_amount !== item.amount) hasWrongAmount = true;



            const userFoods = this.props.data.foods;
            for (let f in userFoods) {
                const fk = f.split('|');
                if (fk[0] == '0') continue;
                const foods = userFoods[f];
                for (let f2 in foods) {
                    const food = foods[f2];
                    if (food.food_id == er.results.required[i].item_id) {

                        let requiredPreparations = er.results.required[i].preparations;

                        let mod = this.props.data.modifications[food.id];
                        if (typeof mod === 'undefined') mod = [];

                        let userPreparations = JSON.parse(JSON.stringify(mod));
                        let diff = [];
                        for (let j in requiredPreparations) {
                            if (!userPreparations.includes(requiredPreparations[j])) {
                                diff.push(requiredPreparations[j]);
                            }

                            let index = userPreparations.indexOf(requiredPreparations[j]);
                            if (index > -1) {
                                userPreparations.splice(index, 1);
                            }
                        }

                        // solve the situation when no preparations (the diff is [0])
                        if(diff.length == 1 && diff[0] == 0) diff = [];
                        //

                        if (diff.length > 0 || userPreparations.length > 0) {
                            hasWrongPrep = true;
                        }
                    }
                }
            }            
        }

        if (er.results.excess.length > 0) hasExcess = true;

        let checks = [];
        checks.push(allFoodGroupsHaveNames ? 'Y ' : 'N ');
        checks.push(allFoodGroupsHaveDescriptions ? 'Y ' : 'N ');
        checks.push(!hasMissing ? 'Y ' : 'N ');
        checks.push(!hasWrongAmount ? 'Y ' : 'N ');
        checks.push(!hasWrongPrep ? 'Y ' : 'N ');
        checks.push(!hasExcess ? 'Y ' : 'N ');


        return (
            allFoodGroupsHaveNames &&
            allFoodGroupsHaveDescriptions &&
            !hasMissing &&
            !hasWrongAmount &&
            !hasWrongPrep &&
            !hasExcess
        );
    }


    tick() {
        const ld = this.props.data.lastSavedAt / 1000;
        const now = Date.now() / 1000;
        const diff = now - ld;
        if (diff > 180) {
            this.setState({
                showSaveWarning: true,
                lastSaveWarningTime: now,
            });
            const d = Date.now();
            this.props.setLastSavedAt(d);
        } else {
            if (this.state.showSaveWarning) {
                if ((now - this.state.lastSaveWarningTime) > 6) {
                    this.setState({
                        showSaveWarning: false
                    });
                }
            }
        }
    }

    openLectureTaskSampleMenu() {
        const sampleRecipeIds = this.props.data.appModeData.lectureInfoData.lecture_data.sample_recipe_ids.split(',');

        // TODO: there could be more recipes than one, so show a list of them
        // for now, get the first ID only
        const id = sampleRecipeIds[0];

        const obfusId = 8800000 + id * 7;      // TODO: this is shitty as fuck, at least make a hash or something
        // (update in lecturetask/load API call too)

        this.props.setAppSubMode('LECTURETASK_SAMPLE');
        this.props.history.push('/load/task/' + obfusId + '/' + this.props.data.appModeData.lectureId);
    }

    showTaskListDDDInfoFunc(info, id, type) {
        let content = [];
        let mealsParts = {};

        let data = this.props.data;

        if (type === 'category') {
            if (typeof info['categories'][id] !== 'undefined') {
                let tmp = {};
                info['categories'][id].map(f => {
                    const mk = f.meal + '|' + f.meal_id;
                    if (typeof tmp[mk] === 'undefined') tmp[mk] = {};
                    if (typeof tmp[mk][f.baseFood.title] === 'undefined') tmp[mk][f.baseFood.title] = [];
                    if (f.baseFood.title !== f.food.title) {
                        tmp[mk][f.baseFood.title].push(f.food.title);
                    }
                });

                Object.keys(data.globals.mealTypes).map(m => {
                    const mt = data.globals.mealTypes[m].title;
                    const mk = mt + '|' + m;
                    if (typeof tmp[mk] !== 'undefined') {
                        content.push(<p><b>{mt}</b></p>);
                        let subresult = [];
                        Object.keys(tmp[mk]).map(fd => {
                            const subFoods = tmp[mk][fd];
                            if (subFoods.length > 0) {
                                subresult.push(<p>{fd}: {subFoods.join(', ')}</p>);
                            } else {
                                subresult.push(<p>{fd}</p>);
                            }
                        });
                        content.push(<div>{subresult}</div>);
                    }
                });

                content = <div className="lecturetask-foodslist">{content}</div>;
            }


            let titlePart = 'Chody/potraviny obsahující'

            this.props.closeModal();
            this.props.openModal({
                title: __('Chody/potraviny obsahující') + ' "' + this.props.data.globals.foodCategories[id].title + '"',
                closeButton: __('Zavřít'),
                class: 'dialog-flexible',
                content: content
            });
        }


        if (type === 'tag') {

            if (typeof info['tags'][id] !== 'undefined') {
                let tmp = {};
                info['tags'][id].map(f => {
                    const mk = f.meal + '|' + f.meal_id;
                    if (typeof tmp[mk] === 'undefined') tmp[mk] = {};
                    if (typeof tmp[mk][f.baseFood.title] === 'undefined') tmp[mk][f.baseFood.title] = [];
                    if (f.baseFood.title !== f.food.title) {
                        tmp[mk][f.baseFood.title].push(f.food.title);
                    }
                });

                Object.keys(data.globals.mealTypes).map(m => {
                    const mt = data.globals.mealTypes[m].title;
                    const mk = mt + '|' + m;
                    if (typeof tmp[mk] !== 'undefined') {
                        content.push(<p><b>{mt}</b></p>);
                        let subresult = [];
                        Object.keys(tmp[mk]).map(fd => {
                            const subFoods = tmp[mk][fd];
                            if (subFoods.length > 0) {
                                subresult.push(<p>{fd}: {subFoods.join(', ')}</p>);
                            } else {
                                subresult.push(<p>{fd}</p>);
                            }
                        });
                        content.push(<div>{subresult}</div>);
                    }
                });

                content = <div className="lecturetask-foodslist">{content}</div>;
            }

            this.props.closeModal();
            this.props.openModal({
                title: 'Chody/potraviny obsahujicí "' + this.props.data.globals.foodTags[id] + '"',
                closeButton: __('Zavřít'),
                class: 'dialog-flexible',
                content: content
            });
        }

    }








    render() {
        const { data } = this.props;
        const { globals } = data;
        const taskData = data.lectureTaskData;

        let evaluationPanelBeforeContent = false;

        let profileId = Util.getActiveProfileId();
        if (typeof data.appModeData.profileId === 'number') {
            profileId = data.appModeData.profileId;
        }

        let evalResults = false;
        let mealsResults = false;
        if (typeof data.evaluationResults === 'object') {
            evalResults = data.evaluationResults.results;
            mealsResults = data.mealsEvaluationResults;
        }

        let tasksList = [];
        let taskCompletedInfo = false;
        let taskCompleted = false;

        let allFoodGroupsMustHaveNamesWarning = false;
        let allFoodGroupsMustHaveDescriptionsWarning = false;
        let allFoodGroupsHaveNames = true;
        let allFoodGroupsHaveDescriptions = true;

        if (typeof taskData.lecture_data === 'object') {

            // Kontrola, jestli jsou vyplneny nazvy skupin potravin

            Object.keys(this.props.data.foodGroups).map(m => {
                let ma = m.split('|');
                if (ma[0] === "0") return;
                const fgm = this.props.data.foodGroups[m];
                Object.keys(fgm).map(fg => {
                    const g = fgm[fg];
                    if (g.title.trim() == '') allFoodGroupsHaveNames = false;

                    const gdesc = g.description ?? '';
                    if (gdesc.trim() == '') allFoodGroupsHaveDescriptions = false;
                });
            });

            let textKey1 = 'Doplňte názvy ke všem receptům!';
            let textKey2 = 'Doplňte popisy přípravy ke všem receptům!';

            if (true) {
                textKey1 = 'Doplňte název receptu';
                textKey2 = 'Doplňte popis přípravy receptu';
            }

            if (!allFoodGroupsHaveNames) {
                allFoodGroupsMustHaveNamesWarning = (
                    <div style={{ display: 'flex', alignItems: 'center', margin: '0', color: '#f00' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '20px', width: '20px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>
                        <span style={{ display: 'inline-block', lineHeight: '100%', padding: '2px 4px' }}>
                            {__(textKey1)}
                        </span>
                    </div>
                );
            }
            if (!allFoodGroupsHaveDescriptions) {
                allFoodGroupsMustHaveDescriptionsWarning = (
                    <div style={{ display: 'flex', alignItems: 'center', margin: '0', color: '#f00' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '20px', width: '20px' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg>
                        <span style={{ display: 'inline-block', lineHeight: '100%', padding: '2px 4px' }}>
                            {__(textKey2)}
                        </span>
                    </div>
                );
            }


            // Watch ZOF attributs ("Sledujte" pri zadavani ukolu u lekce)

            let watchAttribs = [];
            let graph = false;

            let showRI = [
                'potassium', 'calcium', 'magnesium', 'sodium', 'iodine', 'selenium', 'zinc', 'iron', 'iron_hem', 'phosphorus', 'zinc',
                'vitamin_c', 'vitamin_d', 'vitamin_e', 'vitamin_d2', 'vitamin_d3', 'vitamin_a', 'vitamin_b1', 'vitamin_b2', 'vitamin_b3',
                'vitamin_b5', 'vitamin_b6', 'vitamin_b9', 'vitamin_b12', 'vitamin_k'
            ];






            // ATTN TODO -- NK - pro ted nezobrazovat RI, ale proste jen hodnotu
            showRI = [];



            // Show ratio, if both of relevant values are shown before (in "Nutricni hodnoty" part)

            let showRatios = {
                'proteins_ratio': {
                    'after': 'proteins_plant',
                    'depends_on': ['proteins_animal', 'proteins_plant'],
                },
                'fats_saturated_unsaturated_ratio': {
                    'after': 'fats_unsaturated_total',
                    'depends_on': ['fats_saturated', 'fats_unsaturated_total'],
                },
                'fats_monounsaturated_polyunsaturated_ratio': {
                    'after': 'fats_polyunsaturated',
                    'depends_on': ['fats_monounsaturated', 'fats_polyunsaturated'],
                },
                'fats_omega3_omega6_ratio': {
                    'after': 'fats_omega6',
                    'depends_on': ['fats_omega3', 'fats_omega6'],
                },
                'fats_omega3_dha_epa_omega6_ratio': {
                    'after': 'fats_omega6',
                    'depends_on': ['fats_omega3_dha_epa', 'fats_omega6'],
                },
                'fiber_ratio': {
                    'after': 'fiber_soluble',
                    'depends_on': ['fiber_soluble', 'fiber_insoluble'],
                },
                'calcium_magnesium_ratio': {
                    'after': 'magnesium',
                    'depends_on': ['calcium', 'magnesium'],
                },
                'potassium_sodium_ratio': {
                    'after': 'sodium',
                    'depends_on': ['potassium', 'sodium'],
                },
                'calcium_phosphorus_ratio': {
                    'after': 'phosphorus',
                    'depends_on': ['calcium', 'phosphorus'],
                },
            };

            // First check which ratios should be filled

            if (typeof evalResults !== 'undefined') {
                if (Array.isArray(Object.keys(taskData.ddd_limits))) {
                    Object.keys(taskData.ddd_limits).map(attr => {
                        if (attr == '') return;
                        if (attr === 'fats_unsaturated') attr = 'fats_unsaturated_total';
                        Object.keys(showRatios).map(r => {
                            if (showRatios[r].depends_on.includes(attr)) {
                                showRatios[r].depends_on = showRatios[r].depends_on.filter(a => a !== attr);
                            }
                        });
                    });
                }
            }

            // Fill the watchAttribs array

            let watchAttribsAlreadyFilled = [];
            let watchAttribsByKey = {};
            let currEl;

            let watchAttrs = data.appModeData.watchAttributes;
            if (typeof watchAttrs === 'object') {
                if (Util.isCurrentTaskSeminarWork()) {
                    watchAttrs.push('weight');
                    watchAttrs.push('drink_amount');
                }
            }

            if (watchAttrs.includes('fats_unsaturated')) {
                watchAttrs.push('fats_unsaturated_total');
            }

            let lang = localStorage.getItem('zofapp_lang');

            let energyAmountText = 'Množství energie';
            if (Util.getLang() == 'sk') energyAmountText = 'Množstvo energie';

            if (typeof data.evaluationResults !== 'undefined') {
                if (typeof data.evaluationResults.results !== 'undefined') {

                    const thisMealIsEmpty = data.evaluationResults.results.weight === 0 && data.evaluationResults.results.energy_kcal === 0;

                    Object.keys(data.evaluationResults.results).map(attr => {
                        //data.evaluationResults.results.map(attr => {
                        if (attr == '') return;
                        if (attr === 'fats_unsaturated') attr = 'fats_unsaturated_total';
                        if (attr === 'energy_balance_kcal') attr = 'kcal_kj';

                        if (typeof watchAttrs === 'object') {
                            if (watchAttrs.includes(attr)) {

                                //if(typeof data.appModeData.watchAttributes === 'object') {
                                //if(data.appModeData.watchAttributes.includes(attr)) {

                                if (attr == 'kcal_kj') {
                                    let kcal = data.evaluationResults.results['energy_balance_kcal'] + '';
                                    let kj = data.evaluationResults.results['energy_balance_kj'] + '';
                                    if (kcal > 0 && kcal.substr(0, 1) !== '+') kcal = '+' + kcal;
                                    if (kj > 0 && kj.substr(0, 1) !== '+') kj = '+' + kj;

                                    currEl = (
                                        <>
                                            <div className="watch-attribute-row">
                                                <p>{energyAmountText}:</p>
                                                <aside>
                                                    {data.evaluationResults.results['energy_kcal'] * 1}
                                                    {'\u00A0'}
                                                    kcal
                                                </aside>
                                            </div>
                                        </>
                                    );
                                    watchAttribs.push(currEl);
                                    watchAttribsByKey['energy_kcal'] = currEl;

                                    currEl = (
                                        <>
                                            <div className="watch-attribute-row">
                                                <p>{energyAmountText}:</p>
                                                <aside>
                                                    {data.evaluationResults.results['energy_kj']}
                                                    {'\u00A0'}
                                                    kJ
                                                </aside>
                                            </div>
                                        </>
                                    );
                                    watchAttribs.push(currEl);
                                    watchAttribsByKey['energy_kj'] = currEl;

                                    currEl = (
                                        <>
                                            <div className="watch-attribute-row">
                                                <p>{data.globals.attributes['energy_balance_kcal']}:</p>
                                                <aside>
                                                    {kcal}
                                                    {'\u00A0'}
                                                    {data.globals.attribute_units['energy_balance_kcal']}
                                                </aside>
                                            </div>
                                        </>
                                    );
                                    watchAttribs.push(currEl);
                                    watchAttribsByKey['energy_balance_kcal'] = currEl;

                                    currEl = (
                                        <>
                                            <div className="watch-attribute-row">
                                                <p>{data.globals.attributes['energy_balance_kj']}:</p>
                                                <aside>
                                                    {kj}
                                                    {'\u00A0'}
                                                    {data.globals.attribute_units['energy_balance_kj']}
                                                </aside>
                                            </div>
                                        </>
                                    );
                                    watchAttribs.push(currEl);
                                    watchAttribsByKey['energy_balance_kj'] = currEl;

                                } else {

                                    let resval, textEval;

                                    switch (attr) {

                                        case 'gi':

                                            resval = data.evaluationResults.results[attr];
                                            textEval = __('nízký');

                                            if(resval > 50) {
                                                textEval = __('střední');
                                                if(lang == 'sk') textEval = 'stredný';
                                            }


                                            if (resval > 70) textEval = __('vysoký');

                                            if (thisMealIsEmpty) textEval = '-';

                                            currEl = (
                                                <div className="watch-attribute-row">
                                                    <p>{data.globals.attributes[attr]}:</p>
                                                    <aside>
                                                        {textEval}
                                                    </aside>
                                                </div>
                                            );
                                            watchAttribs.push(currEl);
                                            watchAttribsByKey[attr] = currEl;
                                            watchAttribsAlreadyFilled.push(attr);
                                            break;

                                        case 'gn':

                                            // Toto je celodenni vyhodnoceni 
                                            // tj. limity pro GN jsou jine nez pro mod jednoho receptu

                                            resval = data.evaluationResults.results[attr];
                                            textEval = __('nízká');
                                            //if (resval > 80) textEval = __('střední');

                                            if(resval > 80) {
                                                textEval = __('střední');
                                                if(lang == 'sk') textEval = 'stredná';
                                            }


                                            if (resval > 119) textEval = __('vysoká');

                                            if (thisMealIsEmpty) textEval = '-';

                                            currEl = (
                                                <div className="watch-attribute-row">
                                                    <p>{data.globals.attributes[attr]}:</p>
                                                    <aside>
                                                        {textEval}
                                                    </aside>
                                                </div>
                                            );
                                            watchAttribs.push(currEl);
                                            watchAttribsByKey[attr] = currEl;
                                            watchAttribsAlreadyFilled.push(attr);
                                            break;

                                        default:

                                            if (['acidobasicity', 'digestibility', 'energy', 'thermic_effect', 'thermiceffect'].includes(attr)) {

                                                let attrFinal = attr;
                                                if (attrFinal === 'energy') attrFinal = 'energytendency';
                                                if (attrFinal === 'thermic_effect') attrFinal = 'thermiceffect';

                                                let opts = data.globals.evaluationTexts[attrFinal];

                                                let text = opts[Math.round(data.evaluationResults.results[attr + '_n'])];

                                                if (thisMealIsEmpty) text = '-';


                                                currEl = (
                                                    <div className="watch-attribute-row">
                                                        <p>{data.globals.attributes[attr]}:</p>
                                                        <aside>
                                                            {text}
                                                            {'\u00A0'}
                                                            {data.globals.attribute_units[attr]}
                                                        </aside>
                                                    </div>
                                                );
                                                watchAttribs.push(currEl);
                                                watchAttribsByKey[attr] = currEl;
                                                watchAttribsAlreadyFilled.push(attr);

                                            } else {

                                                if (showRI.includes(attr)) {

                                                    if (typeof data.evaluationResults.ddd[attr] !== 'undefined') {
                                                        let RIpct = data.evaluationResults.ddd[attr].percent;
                                                        currEl = (
                                                            <div className="watch-attribute-row">
                                                                <p>{data.globals.attributes[attr]}:</p>
                                                                <aside>
                                                                    {RIpct}
                                                                    {'\u00A0'}
                                                                    % RI
                                                                </aside>
                                                            </div>
                                                        );
                                                        watchAttribs.push(currEl);
                                                        watchAttribsByKey[attr] = currEl;
                                                        watchAttribsAlreadyFilled.push(attr);
                                                    }

                                                } else {

                                                    currEl = (
                                                        <div className="watch-attribute-row">
                                                            <p>{data.globals.attributes[attr]}:</p>
                                                            <aside>
                                                                {data.evaluationResults.results[attr]}
                                                                {'\u00A0'}
                                                                {data.globals.attribute_units[attr]}
                                                            </aside>
                                                        </div>
                                                    );
                                                    watchAttribs.push(currEl);
                                                    watchAttribsByKey[attr] = currEl;
                                                    watchAttribsAlreadyFilled.push(attr);

                                                    if (attr == 'added_sugars') {
                                                        let sugarCubes = data.evaluationResults.results[attr] / 4;
                                                        sugarCubes = Math.ceil(sugarCubes * 10) / 10;
                                                        currEl = (
                                                            <div className="watch-attribute-row">
                                                                <p>- odpovídá kostkám cukru:</p>
                                                                <aside>
                                                                    {sugarCubes}
                                                                </aside>
                                                            </div>
                                                        );
                                                        watchAttribs.push(currEl);
                                                        watchAttribsByKey['added_sugar_cubes'] = currEl;

                                                    }

                                                }

                                            }
                                            break;
                                    }

                                }
                            }
                        }

                        Object.keys(showRatios).map(r => {
                            if (data.appModeData.watchAttributes.includes(r)) return;
                            if (showRatios[r].after === attr && showRatios[r].depends_on.length === 0) {
                                currEl = (
                                    <>
                                        <div className="watch-attribute-row">
                                            <p>{data.globals.attributes[r]}:</p>
                                            <aside>
                                                {data.evaluationResults.results[r]}
                                            </aside>
                                        </div>
                                    </>
                                );
                                watchAttribs.push(currEl);
                                watchAttribsByKey[attr] = currEl;
                                watchAttribsAlreadyFilled.push(r);
                            }
                        });

                    });

                    // Energy ratio chart

                    if (watchAttribs.length > 0) {

                        let results = data.evaluationResults.results;
                        let chartColours = ["#96c999", "#eb714a", "#eae869", "#8bcbce", "#c694be"];

                        let enProt = results["proteins"] * 4.18;
                        let enCarb = results["carbohydrates"] * 4.18;
                        let enFats = results["fats"] * 9;
                        let enFibr = results["fiber"] * 2;

                        let total = enProt + enCarb + enFats + enFibr;
                        if (total == 0) total = 0.00001;

                        enProt = Math.round((enProt / total) * 100);
                        enCarb = Math.round((enCarb / total) * 100);
                        enFats = Math.round((enFats / total) * 100);
                        enFibr = 100 - enProt - enCarb - enFats; //(enFibr / total) * 100;

                        let chart2 = Util.pieChart(
                            [enProt, enCarb, enFats, enFibr],
                            100,
                            100,
                            95,
                            chartColours
                        );

                        graph = (
                            <>
                                <div className="lecturetask-eval-box">
                                    <div className="lt-heading">
                                        <h3>{__('Energetické poměry makroživin')}</h3>
                                        <label htmlFor="lt-cb5">?</label>
                                        <input type="checkbox" id="lt-cb5" />
                                        <div className="lt-help">
                                            <p>Ve vytvořeném jídelníčku sledujte poměry makroživin hodnocení v jejich procentuálním podílu z celkového příjmu energie.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="eval-item">
                                    <div className="svg-wrap">
                                        <svg viewBox="0 0 400 200" width="100%" height="100%">
                                            {chart2}
                                            <rect
                                                x="220"
                                                y="40"
                                                width="20"
                                                height="20"
                                                style={{ fill: chartColours[0], strokeWidth: 0 }}
                                            />
                                            <text fontSize="1.4em" x="250" y="55" fill="#444">
                                                {__('Bílkoviny')} ({parseFloat(enProt)} %)
                                            </text>
                                            <rect
                                                x="220"
                                                y="70"
                                                width="20"
                                                height="20"
                                                style={{ fill: chartColours[1], strokeWidth: 0 }}
                                            />
                                            <text fontSize="1.4em" x="250" y="85" fill="#444">
                                                {__('Sacharidy')} ({parseFloat(enCarb)} %)
                                            </text>
                                            <rect
                                                x="220"
                                                y="100"
                                                width="20"
                                                height="20"
                                                style={{ fill: chartColours[2], strokeWidth: 0 }}
                                            />
                                            <text fontSize="1.4em" x="250" y="115" fill="#444">
                                                {__('Tuky')} ({parseFloat(enFats)} %)
                                            </text>
                                            <rect
                                                x="220"
                                                y="130"
                                                width="20"
                                                height="20"
                                                style={{ fill: chartColours[3], strokeWidth: 0 }}
                                            />
                                            <text fontSize="1.4em" x="250" y="145" fill="#444">
                                                {__('Vláknina')} ({parseFloat(enFibr)} %)
                                            </text>
                                        </svg>
                                    </div>
                                </div>
                            </>
                        );
                    }
                }
            }


            let evaluationPanelBeforeContent_NK = false;

            const er = this.props.data.evaluationResultsNk;
            if (typeof er === 'object') {
                let missingFoods = [];
                for (let i in er.results.required) {
                    if (er.results.required[i].missing) {
                        missingFoods.push(er.results.required[i].title + ' (' + er.results.required[i].amount + ' ' + er.results.required[i].weight_unit + ')');
                    }
                }

                let wrongAmount = [];
                for (let i in er.results.required) {
                    if (!er.results.required[i].missing && (er.results.required[i].user_amount != er.results.required[i].amount)) {
                        wrongAmount.push(er.results.required[i].title + ' (' + er.results.required[i].user_amount + ' ' + er.results.required[i].weight_unit + ' -> ' + er.results.required[i].amount + ' ' + er.results.required[i].weight_unit + ')');
                    }
                }

                let wrongPreparations = [];
                for (let i in er.results.required) {
                    if (er.results.required[i].missing) continue;

                    const userFoods = this.props.data.foods;
                    let wrongPrep = [];
                    for (let f in userFoods) {
                        const fk = f.split('|');
                        if (fk[0] == '0') continue;
                        const foods = userFoods[f];
                        for (let f2 in foods) {
                            const food = foods[f2];
                            if (food.food_id == er.results.required[i].item_id) {

                                let requiredPreparations = er.results.required[i].preparations;

                                let mod = this.props.data.modifications[food.id];
                                if (typeof mod === 'undefined') mod = [];

                                let userPreparations = JSON.parse(JSON.stringify(mod));
                                let diff = [];
                                for (let j in requiredPreparations) {
                                    if (!userPreparations.includes(requiredPreparations[j])) {
                                        diff.push(requiredPreparations[j]);
                                    }

                                    let index = userPreparations.indexOf(requiredPreparations[j]);
                                    if (index > -1) {
                                        userPreparations.splice(index, 1);
                                    }
                                }

                                // solve the situation when no preparations (the diff is [0])
                                if(diff.length == 1 && diff[0] == 0) diff = [];
                                //

                                if (diff.length > 0 || userPreparations.length > 0) {

                                    let prepTitles = [];
                                    for (let k in requiredPreparations) {
                                        prepTitles.push(this.props.data.globals.preparation_types[requiredPreparations[k]]);
                                    }

                                    if (prepTitles.length > 0) {
                                        wrongPrep.push(er.results.required[i].title + ' (' + prepTitles.join(', ') + ')');
                                    } else {
                                        wrongPrep.push(er.results.required[i].title + ' (' + __('žádné úpravy') + ')');
                                    }
                                }
                            }
                        }
                    }

                    if (wrongPrep.length > 0) {
                        wrongPreparations.push(wrongPrep.join(','));
                    }
                }

                let excessFoods = [];
                for (let i in er.results.excess) {
                    excessFoods.push(er.results.excess[i].title);
                }

                let infoMissing = false;
                if (missingFoods.length > 0) {
                    infoMissing = (
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Chybějící potraviny')}</h3>
                            </div>
                            <div>
                                {missingFoods.map((f, i) => {
                                    return <p style={{ lineHeight: '130%', margin: '0 0 0 1em' }} key={i}>{f}</p>
                                })}
                            </div>
                        </div>
                    );
                }

                let infoWrongAmount = false;
                if (wrongAmount.length > 0) {
                    infoWrongAmount = (
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Nesprávné množství potraviny')}</h3>
                            </div>
                            <div>
                                {wrongAmount.map((f, i) => {
                                    return <p style={{ lineHeight: '130%', margin: '0 0 0 1em' }} key={i}>{f}</p>
                                })}
                            </div>
                        </div>
                    );
                }

                let infoWrongPreparations = false;
                if (wrongPreparations.length > 0) {
                    infoWrongPreparations = (
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Chybná příprava surovin')}</h3>
                            </div>
                            <div>
                                {wrongPreparations.map((f, i) => {
                                    return <p style={{ lineHeight: '130%', margin: '0 0 0 1em' }} key={i}>{f}</p>
                                })}
                            </div>
                        </div>
                    );
                }

                let infoExcess = false;
                if (excessFoods.length > 0) {
                    infoExcess = (
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Nadbytečné potraviny')}</h3>
                            </div>
                            <div>
                                {excessFoods.map((f, i) => {
                                    return <p style={{ lineHeight: '130%', margin: '0 0 0 1em' }} key={i}>{f}</p>
                                })}
                            </div>
                        </div>
                    );
                }

                evaluationPanelBeforeContent_NK = (
                    <div style={{ padding: '0 1rem', fontSize: '12px' }}>
                        {infoMissing}
                        {infoWrongAmount}
                        {infoWrongPreparations}
                        {infoExcess}
                    </div>
                );

                if (!infoMissing && !infoWrongAmount && !infoWrongPreparations && !infoExcess) {
                    if(allFoodGroupsHaveNames) {
                        if(allFoodGroupsHaveDescriptions) {
                            evaluationPanelBeforeContent_NK = false;
                            taskCompleted = true;
                            this.updateTaskCompletionStatus();
                        }
                    }
                } else {
                    this.updateTaskCompletionStatus();
                }










                // ============================= NEW ====================================


                // !!!! je potreba to tady zresetovat na false protoze v kodu vyse to muze byt nastasveno na true a tady uz se to potom nezmeni!
                taskCompleted = false;

                let evalFoodsList = [];
                let allFoodsOk = true;
                for (let i in er.results.required) {

                    let prepTitles = [];
                    for(let j in er.results.required[i].preparations) {
                        prepTitles.push(this.props.data.globals.preparation_types[er.results.required[i].preparations[j]]);
                    }

                    if(er.results.required[i].is_ok === true) {
                        evalFoodsList.push(
                            <div className="">
                                <p>
                                    <span style={{color:'#0a0'}}>
                                        <span>{'\u2713'}</span> 
                                        {er.results.required[i].title + ' (' + er.results.required[i].amount + ' ' + er.results.required[i].weight_unit + ')'}
                                    </span>
                                    <br />
                                    <span style={{marginLeft:'1em',color:'#0a0',fontSize:'.9em'}}>{prepTitles.join(', ')}</span>
                                </p>
                            </div>
                        );
                    } else {
                        allFoodsOk = false;
                        evalFoodsList.push(
                            <div className="" style={{lineHeight:'100%'}}>
                                <p>
                                    <span style={{}}>
                                        {er.results.required[i].title + ' (' + er.results.required[i].amount + ' ' + er.results.required[i].weight_unit + ')'}
                                    </span>
                                    <br />
                                    <span style={{fontSize:'.9em'}}>{prepTitles.join(', ')}</span>
                                </p>
                            </div>
                        );
                    }
                }

                evaluationPanelBeforeContent_NK = (
                    <div style={{ padding: '0 1rem', fontSize: '12px', marginBottom: ' 1.5rem' }}>
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Potraviny')}</h3>
                            </div>
                            <div>
                                {evalFoodsList}
                                {infoExcess}
                            </div>
                        </div>
                    </div>
                );
                
                if (allFoodsOk && !infoExcess) {
                    if(allFoodGroupsHaveNames) {
                        if(allFoodGroupsHaveDescriptions) {
                            evaluationPanelBeforeContent_NK = false;
                            taskCompleted = true;
                            this.updateTaskCompletionStatus();
                        }
                    }
                } else {
                    this.updateTaskCompletionStatus();
                }










                // ============================= /NEW ====================================








            }

            let saveWarningText = <p>Úkol je splněn. <b style={{color:'#e00'}}>Nezapomeňte si nyní úkol uložit!</b> Poté si otevřete upravený recept (viz. výše).</p>;
            if (Util.getLang() == 'sk') {
                saveWarningText = <p>Úloha je splnená. <b style={{color:'#e00'}}>Nezabudnite si teraz úlohu uložiť!</b> Potom si otvorte upravený recept (viď vyššie).</p>;
            }

            if(taskCompleted) {
                evaluationPanelBeforeContent_NK = (
                    <div style={{ padding: '0 1rem', fontSize: '12px' }}>
                    <div className="lecturetask-eval-box">          
                        <div className="lt-heading">
                            <h3>Gratulujeme!</h3>            
                        </div>        
                        {saveWarningText}
                    </div>
                    </div>
                )
            }

            if(this.props.data.appSubMode == 'LECTURETASK_SAMPLE') {
                evaluationPanelBeforeContent_NK = false;
            }


            evaluationPanelBeforeContent = (
                <>
                    <div style={{ padding: '0 1rem', fontSize: '12px' }}>
                        <div className="lecturetask-taskslist">{tasksList}</div>
                    </div>
                </>
            );

            let watchAttribsSorted = [];

            let attributeKey, attributeUnit;
            for (let groupKey in this.props.data.globals.evaluation_groups_opened) {
                let subItems = [];
                for (let subGroup in globals.evaluation_groups[groupKey]) {
                    attributeKey = globals.evaluation_groups[groupKey][subGroup];
                    attributeUnit = globals.attribute_units[attributeKey];
                    if (typeof watchAttribsByKey[attributeKey] == "undefined") continue;
                    subItems.push(watchAttribsByKey[attributeKey]);
                }
                if (subItems.length > 0) {
                    watchAttribsSorted.push(
                        <div className="lecturetask-watch-group">
                            <input id={`watchgrp_${groupKey}`} type="checkbox" />
                            <label htmlFor={`watchgrp_${groupKey}`}>
                                <i className="fa fa-angle-right"></i>
                                {groupKey}
                            </label>
                            <div className="wcontent">{subItems}</div>
                        </div>
                    );
                }
            }

            let warnings = false;
            if (allFoodGroupsMustHaveNamesWarning || allFoodGroupsMustHaveDescriptionsWarning) {
                warnings = (
                    <div style={{ margin: '0 1em' }}>
                        <div className="lecturetask-eval-box">
                            <div className="lt-heading">
                                <h3>{__('Upozornění')}</h3>
                            </div>
                            <div>
                                {allFoodGroupsMustHaveNamesWarning}
                                {allFoodGroupsMustHaveDescriptionsWarning}
                            </div>
                        </div>
                    </div>
                );
            }

            if (watchAttribs.length > 0) {
                evaluationPanelBeforeContent = (
                    <>
                        {evaluationPanelBeforeContent_NK}
                        {warnings}
                        <div style={{ padding: '0 1rem', fontSize: '12px' }}>
                            <div className="lecturetask-taskslist">{tasksList}</div>
                            <div className="lecturetask-eval-box">
                                <div className="lt-heading">
                                    <h3>Sledujte</h3>
                                    <label htmlFor="lt-cb4">?</label>
                                    <input type="checkbox" id="lt-cb4" />
                                    <div className="lt-help">
                                        <p>Ve vytvořeném jídelníčku sledujte vybrané nutriční hodnoty. Tyto slouží jako informační doplněk k hodnocení jeho celkové kvality.</p>
                                    </div>
                                </div>
                                {watchAttribsSorted}
                            </div>
                            <div className="lecturetask-eval-box">
                                {graph}
                            </div>
                        </div>
                    </>
                );

            }
        }

        let profileInfoContent = 'Váš profil';
        if (typeof data.appModeData.profileId === 'number') {
            let fpid = data.appModeData.profileId;
            profileInfoContent = globals.profiles[fpid].name;
        }

        if (typeof data.appModeData.profileOverride === 'object') {
            profileInfoContent = data.appModeData.profileOverride.name;
        }


        //

        let saveWarning = false;
        if (this.state.showSaveWarning) {
            saveWarning = <span className="save-warning">Nezapomeňte rozpracovaný úkol průběžně ukládat!</span>;
        }



        //

        // className="accent" 
        let topNavButtons = (
            <>
                <a onClick={this.props.openLoadLectureTaskPanel}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
                    </svg>
                    {__('Načíst úkol')}
                </a>
                <a style={{ background: '#dcf1d5' }} onClick={this.props.openSaveLectureTaskPanel}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    {__('Uložit úkol')}
                </a>
            </>
        );

        // If this task is from UNIVERSAL COURSE, hide load/save buttons
        if (typeof this.props.data.appModeData.lectureInfoData.course_id === 'number') {
            if (this.props.data.appModeData.lectureInfoData.course_id === 46) {
                topNavButtons = false;
            }
        }

        const totalSteps = 2;
        let currentStep = 1;
        let currentStepTitle = __('Tvorba receptu');
        let currentStepButton = (
            <a onClick={this.props.openAssignmentInfo}>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                </svg>
                {__('Zadání')}
            </a>
        );

        if (this.props.data.appSubMode == 'LECTURETASK_SAMPLE') {
            currentStep = 2;
            currentStepTitle = __('Upravený recept');
            currentStepButton = (
                <a onClick={this.props.openLectureTaskSampleText}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                    </svg>
                    {__('Tajemství receptu')}
                </a>
            );
        }

        //let dayTitle = <h1>{__('Úkol k lekci')}: <b>{this.props.lectureInfo.title}</b></h1>;
        let dayTitle = <h1><b>{this.props.lectureInfo.title}</b></h1>;

        let firstGroupHeading = <p><b>Krok {currentStep}/{totalSteps} - {currentStepTitle}</b></p>;
        let firstGroup = (
            <>
                {currentStepButton}
            </>
        );

        let profileGroup = (
            <div className="group">
                <div>
                    <p><b>{__('Cílový profil')}:</b></p>
                    <p>
                        {profileInfoContent}
                        <a style={{ marginLeft: '.5rem' }} onClick={this.props.openProfileInfo}>{__('Více')}</a>
                    </p>
                </div>
            </div>
        );

        // FILTR NA PROFIL BOX - ted skryt, potom kdyz student bude delat jidelnicek, tak zobrazit
        if (true) {
            profileGroup = false;
        }

        if (this.props.data.appSubMode == 'LECTURETASK_SAMPLE') {
            topNavButtons = false;
        }


        let topNavStuff = (
            <>
            {firstGroupHeading}
            {firstGroup}
            {profileGroup}
            {topNavButtons}
            </>
        );


        if(taskCompleted) {

            //currentStep = 2;
            //currentStepTitle = __('Upravený recept');
            //currentStepButton = <a onClick={this.props.openLectureTaskSampleText}>{__('Komentář k upravenému receptu')}</a>

            topNavStuff = (
                <>
                <p><b>Krok {currentStep}/{totalSteps} - {currentStepTitle}</b></p>  
                <a style={{ background: '#dcf1d5' }} onClick={this.props.openSaveLectureTaskPanel}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                    </svg>
                    {__('Uložit úkol')}
                </a>
                <a onClick={() => this.openLectureTaskSampleMenu()}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto' }}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
                    </svg>
                    {__('Otevřít upravený recept')}
                </a>
                </>
            );
        }

/*
                <a onClick={this.props.openLectureTaskSampleText}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{ height: '18px', width: 'auto', display: 'block', margin: '0 auto 5px auto'}}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                    </svg>
                    {__('Komentář')}
                </a>
*/

        let txt1 = 'úkol k lekci';
        if (Util.getLang() == 'sk') {
            txt1 = 'úloha k lekcii';
        }
        


        let content = (
            <>
                <div className="page page-bg page-plan">
                    <div className="page-header" style={{ padding: '0' }}>
                        <div className="container">
                            <div className="page-header-row">
                                <div className="header-group">
                                    <h4 className="lecturetask-course-title">
                                        {this.props.lectureInfo.course_title} - {txt1}
                                    </h4>
                                    {dayTitle}
                                </div>
                                <aside>
                                    {topNavStuff}
                                </aside>
                            </div>
                        </div>
                    </div>

                    <div className="page-content page-content-mobile-nav">
                        <div className="container" style={{ paddingTop: '0' }}>
                            <input className="radio-plan-mobile-nav" name="plan-nav" type="radio" id="cb-plan-main" defaultChecked={true} />
                            <input className="radio-plan-mobile-nav" name="plan-nav" type="radio" id="cb-plan-evaluation" />
                            <div className="plan-mobile-nav">
                                <label htmlFor="cb-plan-main">Rozpis</label>
                                <label htmlFor="cb-plan-evaluation">Vyhodnocení</label>
                            </div>
                            <div className="plan">
                                <div className="plan-row">
                                    <input checked="checked" className="radio-plan-mobile-nav" type="checkbox" id="cb-panel-evaluation" />
                                    <div className="plan-main" style={{ paddingTop: '2em', marginRight: '0em', paddingRight: '2.5em', borderRight: '1px solid #e0e4eb' }}>
                                        <div className="planner-hours">
                                            <div className="planner-top-nav">
                                                {this.props.viewTypeSwitch2}
                                            </div>
                                            {this.props.plan}
                                        </div>
                                    </div>
                                    <EvaluationPanel
                                        beforeContent={evaluationPanelBeforeContent}
                                        wholeDay={true}
                                        quickResults={false}
                                        evaluationCollapsedAtStart={true}
                                        onRecommendedFoodAdded={this.onRecommendedFoodAdded}
                                        mainStyle={{ paddingTop: '2em' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {saveWarning}
            </>
        );

        return content;
    }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LectureTaskPlan));
